import React from "react";
import {
  Paper,
  Typography,
  Box,
  Icon,
  LinearProgress,
  Grid,
} from "@mui/material";

interface HealthIndicatorProps {
  title: string;
  value: number;
  icon: string;
  color: string;
}

const HealthIndicator: React.FC<HealthIndicatorProps> = ({
  title,
  value,
  icon,
  color,
}) => (
  <Paper sx={{ p: 2 }}>
    <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
      <Icon sx={{ color, mr: 1 }}>{icon}</Icon>
      <Typography variant="subtitle1">{title}</Typography>
    </Box>
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ flexGrow: 1, mr: 1 }}>
        <LinearProgress
          variant="determinate"
          value={value}
          sx={{
            height: 8,
            borderRadius: 5,
            backgroundColor: `${color}20`,
            "& .MuiLinearProgress-bar": {
              backgroundColor: color,
            },
          }}
        />
      </Box>
      <Typography variant="body2" color="textSecondary">
        {value}%
      </Typography>
    </Box>
  </Paper>
);

interface SystemHealthProps {
  cpu: number;
  memory: number;
  storage: number;
}

export const SystemHealth: React.FC<SystemHealthProps> = ({
  cpu,
  memory,
  storage,
}) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <HealthIndicator
          title="CPU Usage"
          value={cpu}
          icon="memory"
          color="#2196f3"
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <HealthIndicator
          title="Memory Usage"
          value={memory}
          icon="storage"
          color="#4caf50"
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <HealthIndicator
          title="Storage Usage"
          value={storage}
          icon="database"
          color="#f44336"
        />
      </Grid>
    </Grid>
  );
};
